import { dateDiff } from '@/utils/formatDate';

type PublishedDateProps = {
  publishedAt: string;
};

export function PublishedDate({
  publishedAt,
  ...props
}: PublishedDateProps): JSX.Element {
  return (
    <>
      {publishedAt && (
        <time dateTime={publishedAt} {...props}>
          {dateDiff(publishedAt)}
        </time>
      )}
    </>
  );
}

export default PublishedDate;
